import searchImg from '../../assets/images/search.png';
import history from '../../assets/images/historyIcon.png';
import media from '../../assets/images/media.png';
import inspection from '../../assets/images/inspection.png';
import { useEffect, useState } from 'react';
import InspectionModal from '../Models/InspectionModal';
import security from '../../assets/images/hugeicons_security-check.png';
import Logout from '../../assets/images/material-symbols_logout.png';
import { actions } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { RootState } from '../../store/reducers';
import Security from '../Dashboard/Security';
import Audit from '../../pages/Audit';
import FindTrailer from '../Dashboard/FindTrailer';

interface SidebarProps { onInspectionCreated?: () => void; }

export default function Sidebar({ onInspectionCreated }: SidebarProps) {
    const { inspection: dataInspection } = useSelector((e: RootState) => ({ inspection: e.inspection }))
    const [showModal, setShowModal] = useState(false);
    const [activeTab, setActiveTab] = useState<'inspection' | 'inventory' | 'inspection-old' | 'security' | 'audit' | 'find-trailer' | null>(null);
    const [hoveredTab, setHoveredTab] = useState<'inspection' | 'inventory' | 'history' | 'inspection-old' | 'security' | 'audit' | 'find-trailer' | null>(null);
    const { logout } = actions;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (dataInspection.hasCriticalEvent && !dataInspection.hasModelOpen) {
            dispatch(actions.modelOpen(true))
            setShowModal(true)
        }
    }, [dataInspection.hasCriticalEvent])

    return (
        <>
            <div className='flex flex-col justify-between bg-blue text-white w-32 2xl:w-36 p-3.5 3xl:p-[18px]  items-center z-10'>
                <div className=" flex flex-col space-y-2 3xl:space-y-3 items-center">
                    <h2 className="hidden md:block text-sm sm:text-base md:text-lg text-center font-semibold font-[Geist-semibold]">Quick Jobs</h2>

                    <button
                        onClick={() => setActiveTab('find-trailer')}
                        onMouseEnter={() => setHoveredTab('find-trailer')}
                        onMouseLeave={() => setHoveredTab(null)}
                        className={`w-full flex flex-col justify-center items-center gap-1.5 3xl:gap-3 py-2 px-1.5 border-[2px] border-white rounded transition ${
                            activeTab === 'find-trailer'
                                ? 'bg-white text-blue'
                                : 'hover:bg-white hover:text-[rgb(35,137,160)]'
                        }`}
                    >
                        <Icon
                            icon="material-symbols:search"
                            className={`size-[32px] ${
                                activeTab === 'find-trailer' || hoveredTab === 'find-trailer'
                                    ? 'text-blue'
                                    : 'text-white'
                            }`}
                        />
                        <span className="hidden md:block italic text-sm 2xl:text-base font-bold font-[Acumin-bold]">
                            Find Trailer
                        </span>
                    </button>

                    <button
                        onClick={() => {
                            setActiveTab('inspection-old');
                            navigate('/inspection');
                        }}
                        onMouseEnter={() => setHoveredTab('inspection-old')}
                        onMouseLeave={() => setHoveredTab(null)}
                        className="w-full flex flex-col items-center gap-1.5 3xl:gap-3 py-2 px-1.5 border-[2px] border-white rounded transition hover:bg-white hover:text-[rgb(35,137,160)]">
                        <Icon
                            icon="hugeicons:work-history"
                            className={`size-[32px] ${activeTab === 'inspection-old' || hoveredTab === 'inspection-old' ? 'text-blue' : 'text-white'}`}
                        />
                        <span className="hidden md:block italic text-sm 2xl:text-base font-bold font-[Acumin-bold]">
                            History
                        </span>
                    </button>


                    <button
                        onClick={() => {
                            setActiveTab('audit');
                        }}
                        onMouseEnter={() => setHoveredTab('audit')}
                        onMouseLeave={() => setHoveredTab(null)}
                        className={`w-full flex flex-col items-center gap-1.5 3xl:gap-3 py-2 px-1.5 border-[2px] border-white rounded transition ${activeTab === 'audit' ? 'bg-white text-blue' : 'hover:bg-white hover:text-[rgb(35,137,160)]'}`}
                    >
                        <Icon
                            icon="material-symbols:fact-check-outline"
                            className={`size-[32px] ${
                                activeTab === 'audit' || hoveredTab === 'audit'
                                    ? 'text-blue'
                                    : 'text-white'
                            }`}
                        />

                        <span className="hidden md:block italic text-sm 2xl:text-base font-bold font-[Acumin-bold]">
                            Audit
                        </span>
                    </button>

                    <button
                        onClick={() => {
                            setActiveTab('inventory');
                            navigate('/inventory');
                        }}
                        onMouseEnter={() => setHoveredTab('inventory')}
                        onMouseLeave={() => setHoveredTab(null)}
                        className={`w-full flex flex-col items-center gap-1.5 3xl:gap-3 py-2 px-1.5 border-[2px] border-white rounded transition ${activeTab === 'inventory' ? 'bg-white text-blue' : 'hover:bg-white hover:text-[rgb(35,137,160)]'}`}
                    >
                        <Icon
                            icon="material-symbols:inventory-2"
                            className={`size-[32px] ${activeTab === 'inventory' || hoveredTab === 'inventory' ? 'text-blue' : 'text-white'}`}
                        />
                        <span className={`hidden md:block italic text-sm 2xl:text-base font-bold font-[Acumin-bold] ${activeTab === 'inventory' ? 'text-blue' : ''}`}>
                            Inventory
                        </span>
                    </button>

                    <button
                        onClick={() => setActiveTab('inspection')} onMouseEnter={() => setHoveredTab('inspection')} onMouseLeave={() => setHoveredTab(null)}
                        className={`w-full flex flex-col items-center gap-1.5 3xl:gap-3 py-2 px-1.5 border-[2px] border-white rounded transition ${activeTab === 'inspection' ? 'bg-white text-blue' : 'hover:bg-white hover:text-[rgb(35,137,160)]'}`}
                    >
                        <Icon
                            icon="icon-park-outline:inspection"
                            className={`size-[32px] ${activeTab === 'inspection' || hoveredTab === 'inspection' ? 'text-blue' : 'text-white'}`}
                        />

                        <span className={`hidden md:block italic text-sm 2xl:text-base font-bold font-[Acumin-bold] ${activeTab === 'inspection' ? 'text-blue' : ''}`}>
                            Inspection
                        </span>
                    </button>
                    <button
                        onClick={() => setActiveTab('security')}
                        onMouseEnter={() => setHoveredTab('security')}
                        onMouseLeave={() => setHoveredTab(null)}
                        className={`w-full flex flex-col items-center gap-1.5 3xl:gap-3 py-2 px-1.5 border-[2px] border-white rounded transition ${activeTab === 'security' ? 'bg-white text-blue' : 'hover:bg-white hover:text-[rgb(35,137,160)]'}`}
                    >
                        <Icon
                            icon="hugeicons:security-check"
                            className={`size-[32px] ${
                                activeTab === 'security' || hoveredTab === 'security'
                                    ? 'text-blue'
                                    : 'text-white'
                            }`}
                        />

                        <span className={`hidden md:block italic text-sm 2xl:text-base font-bold font-[Acumin-bold] ${activeTab === 'security' ? 'text-blue' : ''}`}>
                            Security
                        </span>
                    </button>

                    {showModal && <div className="modal"><button onClick={() => setShowModal(false)}></button></div>}
                </div>
                <div className='flex gap-2 cursor-pointer' onClick={() => dispatch(logout())}>
                    <img src={Logout} alt="" />
                    <span className='text-white  font-[Acumin-semibold] text-sm md:text-base'>Log Out</span>
                </div>
            </div>


            {
                activeTab === 'inspection' &&
                <InspectionModal
                    isOpen={true}
                    onClose={() => setActiveTab(null)}
                    onInspectionCreated={onInspectionCreated}
                />
            }

            {
                activeTab === 'security' &&
                <Security onClose={() => setActiveTab(null)} />
            }

            {
                activeTab === 'audit' &&
                <Audit onClose={() => setActiveTab(null)} />
            }

            {
                activeTab === 'find-trailer' &&
                <FindTrailer onClose={() => setActiveTab(null)} />
            }
        </>
    );
};